import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import { PropsWithChildren } from 'react'
import { useUiKit } from '../providers'

export const OverlayScrollBars = ({ children }: PropsWithChildren) => {
  const { isThemeDark } = useUiKit()

  return (
    <OverlayScrollbarsComponent
      options={{
        overflow: {
          x: 'scroll',
          y: 'hidden'
        },
        scrollbars: {
          autoHide: 'leave',
          autoHideDelay: 500,
          dragScroll: true,
          theme: isThemeDark ? 'os-theme-light' : 'os-theme-dark'
        }
      }}
      defer
    >
      {children}
    </OverlayScrollbarsComponent>
  )
}
